var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-align_center" }, [
    _c("div", { staticClass: "el-section" }, [
      _c(
        "div",
        { staticClass: "el-empty _size_medium" },
        [
          _c(
            "div",
            { staticClass: "emeraldraws flex flex-col items-center" },
            [_c("emerald-icon", { attrs: { icon: _vm.drawEntity } })],
            1
          ),
          _vm.hasSlotedTitle
            ? _vm._t("slotedTitle")
            : _c(
                "p",
                { staticClass: "emd-text _color_subtle _type_caption eu-mt_3" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t(`empty-list.${_vm.entity}.no-results`)) +
                      " "
                  ),
                ]
              ),
          _vm.hasSlotedDesc
            ? _vm._t("slotedDesc")
            : _c("p", { staticClass: "emd-text _color_subtle eu-mt_3" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t(`empty-list.${_vm.entity}.description`)) +
                    " "
                ),
              ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }